<template>

  <div class="no-table-box no-card-base">
    <el-tabs v-model="activeTab" type="card">
      <el-tab-pane label="Call History" name="Call History" v-loading="callDataLoading">
        <div class="item-list">
          <call
            v-for="item in callHistoryList"
            :key="item.id"
            :startTime="item.start"
            :callNumber="item.dialDirection === 'outbound' || item.direction === 'OUT' ? item.dialedNum : item.callerIdNumber"
            :callerId="getCallerIdName(item)"
            :talkTime="item.duration"
            :direction="item.dialDirection"
            :disposition="item.disposition"
          />
        </div>
      </el-tab-pane>
      <el-tab-pane label="Voicemails" name="Voicemails">
        <div class="tab-label" slot="label">
          <div>Voicemails</div>
        </div>

        <div class="item-list">
          <voicemail
            v-for="item in voicemailList"
            :key="item.id"
            :id="item.id"
            :time="item.origTime"
            :duration="item.duration"
            :callerIdName="formatCallerId(item.callerId)"
            :callerIdNum="formatCallerNum(item.callerId)"
            :status="item.status"
            :dir="item.dir"
            @voicemailRead="unreadVoicemails--"
            @newVoicemail="unreadVoicemails++">
          </voicemail>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>

import Call from "./components/call";
import Voicemail from "./components/voicemail";
import {mapActions, mapGetters} from "vuex";
import feathersClient from "@/feathers/feathers-client";
import {globalEventBus} from "@/globalEventBus";
import moment from 'moment-timezone';
import {phoneNumberFormatter} from "@/globals/globals";

export default {
  name: 'MyActivity',
  components: {Call, Voicemail},
  data(){
    return {
      searchCalls: '',
      callDataLoading: false,
      voicemailDataLoading: false,
      callsCount: '',
      callHistoryLength: '',
      activeTab: 'Call History',
      userConfigured: true,
      unreadVoicemails: 0,
    }
  },
  computed: {
    ...mapGetters('call-history', {getCDRList: 'find'}),
    ...mapGetters('voicemails', {getVoicemailBox: 'get'}),
    ...mapGetters('phonebook-entries', {getPhonebookEntriesList: 'find'}),
    selectedTenant(){
      return this.$store.getters.selectedTenant;
    },
    user(){
      return this.$store.state.auth.user;
    },
    callHistoryList(){

      return this.getCDRList({
        sort: {start: -1}
      }).data;

    },
    voicemailList(){
      if(this.user.hasOwnProperty('myExtension')){
        if(this.user.myExtension.voicemailId){
          const mailbox = this.getVoicemailBox(this.user.myExtension.voicemailId);
          if(mailbox){
            return mailbox.messages;
          }
        }
      }
      return {};
    },
    voicemailUnreadCount(){
      return this.$store.state.voicemailCount;
    },
    userOffsetMinutes() {
      return this.$store.state.userTimeOffset;
    }
  },
  methods: {
    ...mapActions('call-history', {findCDR: 'find'}),
    ...mapActions('voicemails', {getVoicemail: 'get'}),

    formatCallerId(item) {
      return item ? item.split('<')[0].replace(/['"]+/g, '') : item;
    },

    formatCallerNum(item){
      if(item){
        const callerName = item.split('<')[1];
        if(callerName){
          return callerName.replace(/['"<>]+/g, '');
        }
      }
      return item;
    },
    getCallerIdName(item) {

      let name = '';
      if(item.dialDirection === 'inbound' || item.direction === 'IN'){
        name = item.callerIdNumber
      }

      if(item.dialDirection === 'outbound' || item.direction === 'OUT'){
        name = item.dialedNum;
      }

      if(item.dialDirection === 'inbound' && item.direction === 'INTERNAL'){
        name = item.callerName;
        return name;
      }

      const queryPhonebook = this.getPhonebookEntriesList({
        query: {
          PHONE1: name
        }
      }).data;

      if(queryPhonebook.length){
        const {FIRSTNAME, LASTNAME} = queryPhonebook[0];
        name = `${FIRSTNAME} ${LASTNAME}`;
        return name;
      }

      return '';
    },

    queryCalls(){
      this.callDataLoading = true;
      const params = {
        query: {
          queryType: 'myActivity',
          tenantId: this.user.myExtension.tenantId,
          startDate: moment().subtract(5, 'days').startOf('day').format('YYYY-MM-DD HH:mm:ss'),
          endDate: moment().add(1, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss'),
          primaryFilter: 'user',
          extNumber: this.user.myExtension.number,
          timezone: this.user.timezone,
          exportCSV: false,
          dispositions: ['ANSWERED', 'NO ANSWER', 'BUSY', 'FAILED'],
          direction: 'All',
          $limit: 100,
          $skip: 0
        }
      };

      this.findCDR(params).then((res) => {
        this.callDataLoading = false;
        this.callHistoryLength = res.data.length;
      });
    },

    queryVoicemails(){
      this.voicemailDataLoading = true;
      this.getVoicemail(this.user.myExtension.voicemailId);
    },

    numberFormatter(row, column, value) {
      return value ? phoneNumberFormatter(value) : this.user.email;
    },
    timeFormatter(row, column, value) {

      const offsetMinutes = Math.abs(this.userOffsetMinutes);

      return this.userOffsetMinutes < 0
        ? moment(value).subtract(offsetMinutes, 'minutes').format('M/DD h:mm A')
        : moment(value).add(offsetMinutes, 'minutes').format('M/DD h:mm A');

    },
    removeListeners(){
      const channelService = feathersClient.service('channel-memberships');
      channelService.removeListener('newVoicemail');
      channelService.removeListener('notifyNewCall');
      globalEventBus.$off('appReconnected');
    }
  },
  created(){
    if(this.user){
      if(this.user.hasOwnProperty('myExtension')){
        //grabs business contacts on user's extension tenant
        this.queryCalls();
        if(this.user.myExtension.voicemailId){
          this.queryVoicemails();
        }
      } else {
        this.$notify({
          title: 'Warning',
          message: 'Your Account Has No Assigned Extension',
          type: 'warning'
        });
        this.userConfigured = false;
      }
    }
  },
  mounted(){
    //service for joining appropriate app channels
    const channelService = feathersClient.service('channel-memberships');

    channelService.on('newVoicemail', item => {
      this.getVoicemail(this.user.myExtension.voicemailId);
    });
    channelService.on('notifyNewCall', item => {
      const {uniqueId, direction, disposition, callerName, callerIdNumber, dialedNum, start, duration } = item;
      let callItem = {uniqueId, direction,disposition, callerIdNumber, callerName, dialedNum, duration, start};
      callItem.dialDirection = direction === 'OUT' ? 'outbound' : 'inbound';

      if(direction === 'INTERNAL'){
        const {number} = this.user.myExtension;

        if(+dialedNum !== +number){
          callItem.dialDirection = 'outbound'
        }
      }

      this.$store.commit('call-history/addItem', callItem);
    });
  },
  beforeDestroy() {
    this.$store.commit('call-history/clearList');
    this.$store.commit('voicemails/clearList');
    this.$store.commit('zeroVoicemailCount');
    this.removeListeners();
  }
}

</script>

<style lang="scss" scoped>

@import '../../../../assets/scss/variables';

.download-button{
  width: 20px;
  height: 20px;
}

.list-search-input{
  width: 25%;
  min-width: 200px;
  margin-top: 0px;
  margin-left: 0px !important;
}

.el-tabs--top{
  //margin-top: 10px;
  margin-left: 0px !important;
}

.card-base form{
  padding-top: 0;
}

.card-base .form-section-header{
  margin:10px 0;
}

.table-box, .no-table-box{
  height: calc(100% - .7em);
  overflow: hidden;
}

.item-list{
  margin-top: 10px;
  max-height: 335px;
  overflow-y: auto;
}

.el-checkbox-group{
  display: flex;
}

.box{
  >*{
    margin-left: 10px;
    margin-right: 10px;
  }
}

.inbound-outbound-filter{
  margin-bottom: 20px;
  margin-top: 10px;
}

.tab-label{
  position: relative;
  display: flex;
}

.number-badge{
  margin-top: -8px;
}

@media (max-width: 959px){
  #recent-calls-view, #contacts-view, #personal-contacts-view{
    .box{
      flex-wrap: wrap;
    }
  }
}

@media (max-width: 499px){
  .el-checkbox-group{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .box{
    >*{
      flex-basis: 100%;
    }
    .black-text{
      flex-basis: 100%;
      margin-bottom: 20px;
    }
    .list-search-input{
      margin-left: 10px !important;
    }
    .call-item{
      margin-right: 10px;
    }
  }

  #calls-count{
    text-align:center !important;
  }

  .inbound-outbound-filter{
    display: flex;
    justify-content: center;
  }
}

</style>
